import { createApi } from '@reduxjs/toolkit/query/react';
import customFetchBase from '@/app/common/utils/customFetchBase';
import { priceApiPath } from '@/app/common/api/config';
import type {
  DashboardNotifsResponse,
  FeaturesBaseResponse,
  FeaturesResponse,
  PanelsResponse
} from '@/app/Report/types/priceApiTypes';

const priceApi = createApi({
  reducerPath: 'priceApi',
  baseQuery: (...args: unknown[]) =>
    customFetchBase(priceApiPath(), ...args),
  endpoints: build => ({
    getPanels: build.query<PanelsResponse, void>({
      query: () => `/Panels/records`
    }),
    getFeatures: build.query<FeaturesResponse, void>({
      query: () => `/Panels_Feature/records?perPage=80`
    }),
    getFeaturesBase: build.query<FeaturesBaseResponse, void>({
      query: () => `/Panels_Feature_Base/records`
    }),
    getDashboardNotifs: build.query<DashboardNotifsResponse, void>({
      query: () => `/Notif_Dashboard/records/?perPage=10&sort=-order`
    })
  })
});

export const {
  useGetFeaturesQuery,
  useGetPanelsQuery,
  useGetFeaturesBaseQuery,
  useGetDashboardNotifsQuery
} = priceApi;

export default priceApi;
